import { useAuthStore } from '../stores/authStore';

/** Scope for user-specific offline caches (scan context, etc.). */
export function getOfflineUserScope() {
  const userId = useAuthStore.getState().user?.id;
  return userId ? `user_${userId}` : 'anonymous';
}

/** Per-user, per-project scope for register/type offline caches. */
export function getAssetProjectScope(projectId) {
  if (!projectId) return getOfflineUserScope();
  return `${getOfflineUserScope()}:${projectId}`;
}
